import React, { useState } from 'react';
import styles from './ClipsList.module.css';

/**
 * Youtubeクリップをページネーションで表示するコンポーネント
 * @param {object} props
 * @param {Array<object>} props.clips - 表示するクリップデータの配列
 * @param {string} props.clips[].id - クリップのID
 * @param {string} props.clips[].title - クリップのタイトル
 * @param {string} props.clips[].thumbnail_url - クリップのサムネイル画像URL
 * @param {string} props.clips[].video_url - クリップの視聴URL
 * @param {string} props.clips[].published_at - クリップの公開日時
 */
const YouTubeClipsList = ({ clips }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6; // 1ページあたりのクリップ数

  if (!clips || clips.length === 0) {
    return null;
  }

  const totalPages = Math.ceil(clips.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndex + itemsPerPage;
  const currentClips = clips.slice(startIndex, endIndex);

  return (
    <div className={styles.clipsListContainer}>
      <h4>Latest Clips (YouTube)</h4>
      <div className={styles.clipsGrid}>
        {currentClips.map((clip) => (
          <a href={clip.video_url} key={clip.id} target="_blank" rel="noopener noreferrer" className={styles.clipItem}>
            <img src={clip.thumbnail_url} alt={clip.title} className={styles.thumbnail} />
            <div className={styles.clipTitle}>{clip.title}</div>
            <div className={styles.clipDate}>{new Date(clip.published_at).toLocaleDateString('ja-JP', { year: 'numeric', month: 'numeric', day: 'numeric' })}</div>
          </a>
        ))}
      </div>
      {totalPages > 1 && (
        <div className={styles.pagerDots}>
          {[...Array(totalPages)].map((_, dotIndex) => (
            <span
              key={dotIndex}
              className={`${styles.dot} ${dotIndex + 1 === currentPage ? styles.activeDot : ''}`}
              onClick={() => setCurrentPage(dotIndex + 1)}
              role="button"
              data-testid={`pagination-youtube-dot-${dotIndex + 1}`}
            ></span>
          ))}
        </div>
      )}
    </div>
  );
};

export default YouTubeClipsList; 